// extracted by mini-css-extract-plugin
export var buttonsWrapper = "MobileShareButton-module--buttons-wrapper--6da82";
export var open = "MobileShareButton-module--open--69f8f";
export var shareIcon = "MobileShareButton-module--share-icon--4ae51";
export var wrapper = "MobileShareButton-module--wrapper--a41eb";